
import Chart from '../Charts/Chart';

const ExpenseChart = (props) => {
    
    const chartDataPoints = [
        {label: "Jan", value: 0},
        {label: "Feb", value: 0},
        {label: "Mar", value: 0},
        {label: "Apr", value: 0},
        {label: "May", value: 0},
        {label: "Jun", value: 0},
        {label: "July", value: 0},
        {label: "Aug", value: 0},
        {label: "Sept", value: 0},
        {label: "Oct", value: 0},
        {label: "Nov", value: 0},
        {label: "Dec", value: 0}
    ]

    props.items.forEach(expense => {
        const Month = expense.date.getMonth(); // Jan = 0
        chartDataPoints[Month].value += expense.amount;

    })
    
    return (
    <Chart dataPoints={chartDataPoints} />
    )
}

export default ExpenseChart;